import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, OnInit, Inject } from '@angular/core';
import { IsJson, MinifyJson, TryParseJsonWithErrorDetails } from '../../../shared/utils/json.utils';
import { CodeEditorMode, EditorEvent } from './configurationEditor.component';

type MessageType = 'error' | 'warning' | 'success' | 'info';

@Component({
  selector: 'app-configuration-editor-modal',
  templateUrl: '../templates/configurationEditorModal.component.html',
})
export class ConfigurationEditorModalComponent implements OnInit {
  title: string;
  disableValidateButton: boolean;
  message: { type: MessageType, content: string } | null = null;

  editorText: string;
  editorMode: CodeEditorMode;

  input: { text: string, appName: string, configKey: string };

  constructor(private dialogRef: MatDialogRef<ConfigurationEditorModalComponent>, @Inject(MAT_DIALOG_DATA) input) {
    this.input = {
      text: input.text,
      configKey: input.configKey,
      appName: input.appName,
    };
  }

  ngOnInit() {
    this.setModalTitle(this.input.appName, this.input.configKey);
    this.setEditorText(this.input.text);
    this.validateIfJsonAndSetMessage();
  }

  validateValue() {
    this.validateIfJsonAndSetMessage();
  }

  updateValue() {
    const isJson = IsJson(this.editorText);
    const configValue = isJson ? MinifyJson(this.editorText) : this.editorText;
    const canSave = !isJson || this.validateIfJsonAndSetMessage();

    if (canSave) {
      this.dialogRef.close({ shouldUpdate: true, configValue });
    }
  }

  close() {
    this.dialogRef.close({ shouldUpdate: false });
  }

  onEditorTextChange(newText: string) {
    this.setEditorText(newText);
    this.validateIfJsonAndSetMessage();
  }

  onEditorEvent(event: EditorEvent) {
    if (event && event.type === 'syntaxError') {
      this.message = { type: 'error', content: event.data };
    }
  }

  onEditorModeChange(newMode: CodeEditorMode) {
    this.editorMode = newMode;

    const isJsonMode = this.editorMode === 'json';
    this.disableValidateButton = !isJsonMode;

    if (isJsonMode) {
      this.validateIfJsonAndSetMessage();
    } else {
      this.message = { type: 'info', content: 'The config is not a json. No need to validate it' };
    }
  }

  private validateIfJsonAndSetMessage() {
    if (this.editorMode !== 'json') {
      return false;
    }

    const [isValidJson, errorMessage] = this.validateJson();
    this.message = isValidJson
      ? { type: 'success', content: 'The Json is valid' }
      : { type: 'error', content: errorMessage };
    return isValidJson;
  }

  private validateJson(): [boolean, string | null] {
    const [isValidJson, errorMessage] = TryParseJsonWithErrorDetails(this.editorText);
    return [isValidJson, errorMessage];
  }

  private setModalTitle(appName: string, configKey) {
    this.title = `${appName} - ${configKey}`;
  }

  private setEditorText(text: string) {
    this.editorText = text;
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/components/scripts/configurationEditorModal.component.ts